import type { ReactNode } from "react"
import { cn } from "@/lib/utils"

export interface OptimizerRunningBannerProps {
  message?: ReactNode
  className?: string
}

export function OptimizerRunningBanner({
  message = "Scanning parameter combinations... results update as new winners are found",
  className,
}: OptimizerRunningBannerProps) {
  return (
    <div
      className={cn(
        "flex items-center gap-2 px-3 py-2 rounded-md bg-primary/10 border border-primary/30",
        className,
      )}
    >
      <div className="w-3 h-3 rounded-full border-2 border-primary/30 border-t-primary animate-spin" />
      <span className="text-caption text-primary">{message}</span>
    </div>
  )
}
